import {
  getFPlusHighlighter,
  getLoadedFPlusHighlighter,
} from '@festina-life/fplus-monaco'
import { use } from 'react'
import type { HighlighterCore } from 'shiki/core'

import { fplusHighlighterProps } from './fplusHighlighterProps'

/**
 * The shared F-plus highlighter, ready to highlight. It suspends only while the
 * highlighter is still loading — once it is there, every render is synchronous,
 * so a read-only expression is highlighted the first time a reader sees it.
 *
 * `use` may be called conditionally, which is exactly what makes that possible.
 */
export const useFPlusHighlighter = (): HighlighterCore =>
  getLoadedFPlusHighlighter() ?? use(getFPlusHighlighter(fplusHighlighterProps))
